export default "__VITE_ASSET__BC2V8PYg__"